<template>
  <div class="logistics-add-driver">
    <div class="modal logistics-add-driver-modal">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" aria-label="close" @click="closeModal" />
      <div class="modal-card">
        <section class="modal-card-body">
          <div class="has-text-left is-size-5" style="margin-bottom:20px">
            <p class="is-size-4 has-text-link">{{ $t("logistics.add-driver-to-fleet") }}</p>
            <p>
              <a
                v-for="f in fleets"
                :key="f.id"
                class="button is-rounded"
                :class="{'is-link': f === selected}"
                @click="selected = f"
              >{{ f.name }}</a>
            </p>
          </div>

          <div class="field has-addons columns is-centered">
            <div class="control is-medium">
              <a
                class="button is-link is-medium is-rounded"
                style="padding:0px 12px"
                @click="openCountryCodeModal"
              >{{ countryCode }}</a>
            </div>
            <div class="control">
              <input
                v-model="phoneNumber"
                class="input is-info is-medium has-text-centered is-rounded"
                type="number"
                maxlength="12"
                placeholder="123456789"
              />
            </div>
            <div class="control is-medium">
              <a
                class="button is-success is-medium is-rounded"
                :class="{'pulse': phoneNumber.length > 6}"
                style="padding:0px 18px"
                @click="preSubmit"
              >
                <i class="fa fa-chevron-right" />
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>

    <CountryCodeModal @countryCode="onCountryCode" />
  </div>
</template>

<script>
// import EventBus from "../eventBus";
import CountryCodeModal from "@/components/CountryCodeModal.vue";

export default {
  name: "LogisticsAddDriverModal",
  components: {
    CountryCodeModal
  },
  props: {
    fleets: Array
  },
  data() {
    return {
      selected: null,
      workflow: null,
      //   roles: [],
      countryCode: "+66",
      phoneNumber: ""
      //   role: null
      //   sms: false
    };
  },
  computed: {
    workflowName() {
      if (!this.workflow) return null;
      return this.workflow.name;
    }
  },
  mounted() {
    // EventBus.$on("WORKFLOW_ADD_ROLE", data => {
    //   this.workflow = data.workflow;
    //   this.roles = data.roles;
    // });
  },
  methods: {
    closeModal() {
      this.phoneNumber = "";
      this.selected = null;
      //   this.sms = false;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    openCountryCodeModal() {
      this.displayModal(".country-code-modal");
    },
    onCountryCode(val) {
      this.countryCode = val;
    },
    parsePhoneNumber() {
      var cleanNumber = this.phoneNumber;
      // skip initial 0 for Thai numbers
      if (this.phoneNumber[0] === "0") {
        cleanNumber = this.phoneNumber.substring(1, this.phoneNumber.length);
      }
      return this.countryCode + cleanNumber;
    },
    preSubmit() {
      if (this.phoneNumber.length < 7) {
        return this.errorToast("Phone number too short");
      }
      if (!this.selected) {
        if (this.fleets.length === 1) this.selected = this.fleets[0];
        else return this.errorToast("Select a fleet");
      }
      this.submit();
    },
    submit() {
      var w = this.selected;
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("createRole", {
          phone_number: this.parsePhoneNumber(), //this.phoneNumber,
          business_id: w.business_id,
          workflow_id: w.id,
          workflow_name: w.name,
          role_type: "worker",
          role_name: "Driver"
        })
        .then(() => {
          this.successToast("Driver added!");
          this.closeModal();
        })
        .catch(err => this.apiError(err))
        .finally(() => loader.hide());
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  border-radius: 25px;
  padding-top: 16px;
  padding-bottom: 36px;
}
.card-content {
  padding: 6px;
  overflow: hidden !important;
}
p {
  margin-bottom: 8px;
}
p .button {
  margin-right: 4px;
  padding: 0 8px;
  margin-bottom: 6px;
}
.pulse {
  animation: shadow-pulse 1s infinite;
  z-index: 2;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px yellow;
  }
  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 0, 0.5);
  }
}
</style>


